"use strict";

exports.__esModule = true;
exports.updateValueByIdentifier = updateValueByIdentifier;
exports.getValueByIdentifier = getValueByIdentifier;
exports.getTitle = getTitle;
exports.getDescription = getDescription;
exports.getCanonical = getCanonical;
exports.getMetaTags = getMetaTags;
exports.setTitle = setTitle;
exports.setDescription = setDescription;
exports.setCanonical = setCanonical;
exports.setIndexable = setIndexable;
exports.addSchema = addSchema;
exports.addMetaTag = addMetaTag;

var _resolve = require("./private/renderer/resolve");

exports.resolve = _resolve.resolve;

var _resolveWithPatterns = require("./private/renderer/resolve-with-patterns");

exports.resolveWithPatterns = _resolveWithPatterns.resolveWithPatterns;

var _resolvePayload = require("./private/renderer/resolve-payload");

exports.resolvePayload = _resolvePayload.resolvePayload;

var _TagTypes = require("./private/types/TagTypes");

var _ContextProps = require("./private/types/ContextProps");

exports.CONTEXT_PROPS = _ContextProps.CONTEXT_PROPS;

var _ItemTypes = require("./private/types/ItemTypes");

exports.ITEM_TYPES = _ItemTypes.ITEM_TYPES;

var _Identifiers = require("./private/types/Identifiers");

exports.EXTERNAL_IDENTIFIERS = _Identifiers.EXTERNAL_IDENTIFIERS;

var _getByIdentifier = require("./private/tags/values/get-by-identifier");

var _updateByIdentifier = require("./private/tags/values/update-by-identifier");

var _identify = require("./private/renderer/utils/identify");

var _clone = require("./private/renderer/utils/clone");

var _filterPageLevelTags = require("./private/tags/filters/filter-page-level-tags");

exports.filterPageLevelTags = _filterPageLevelTags.filterPageLevelTags;

var _renderToStaticMarkup = require("./private/renderer/render-to-static-markup");

exports.renderToStaticMarkup = _renderToStaticMarkup.renderToStaticMarkup;

var _adapters = require("./private/adapters");

exports.getAdapter = _adapters.getAdapter;

var _patterns = require("./private/patterns");

exports.getPatternBlob = _patterns.getPatternBlob;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function updateValueByIdentifier(data, identifier, value, meta) {
  if (data === void 0) {
    data = {};
  }

  var tags = data && data.tags || [];
  var updatedTags = (0, _updateByIdentifier.updateValueByIdentifier)(tags, identifier, value, meta);
  return _objectSpread({}, data, {
    tags: updatedTags
  });
}

function getValueByIdentifier(_temp, identifier) {
  var _ref = _temp === void 0 ? {} : _temp,
      tags = _ref.tags;

  return (0, _getByIdentifier.getValueByIdentifier)(tags, identifier);
}

function getTitle(data) {
  return getValueByIdentifier(data, _Identifiers.EXTERNAL_IDENTIFIERS.TITLE);
}

function setTitle(data, title) {
  return updateValueByIdentifier(data, _Identifiers.EXTERNAL_IDENTIFIERS.TITLE, title);
}

function getDescription(data) {
  return getValueByIdentifier(data, _Identifiers.EXTERNAL_IDENTIFIERS.DESCRIPTION);
}

function setDescription(data, description) {
  return updateValueByIdentifier(data, _Identifiers.EXTERNAL_IDENTIFIERS.DESCRIPTION, description);
}

function getCanonical(data) {
  return getValueByIdentifier(data, _Identifiers.IDENTIFIERS.CANONICAL);
}

function setCanonical(data, canonical) {
  return updateValueByIdentifier(data, _Identifiers.EXTERNAL_IDENTIFIERS.CANONICAL, canonical);
}

function setIndexable(data, indexable) {
  return updateValueByIdentifier(data, _Identifiers.EXTERNAL_IDENTIFIERS.ROBOTS, indexable ? 'index' : 'noindex');
}

function getMetaTags(data, filter) {
  var tags = (data || {}).tags;

  if (Array.isArray(tags)) {
    return tags.reduce(function (acc, curr) {
      if (curr && curr.type === _TagTypes.TAG_TYPES.META && curr.props) {
        if (filter) {
          var matches = Object.keys(filter).every(function (key) {
            return curr.props[key] === filter[key];
          });

          if (!matches) {
            return acc;
          }
        }

        return acc.concat(curr.props);
      }

      return acc;
    }, []);
  }

  return [];
}

function addSchema(data, json) {
  if (!json || typeof json !== 'object' || Array.isArray(json)) {
    return data;
  }

  var result = (0, _clone.clone)(data);
  result.tags.push({
    type: _TagTypes.TAG_TYPES.SCRIPT,
    props: {
      type: 'application/ld+json'
    },
    children: JSON.stringify(json)
  });
  return result;
}

function addMetaTag(data, props) {
  var identifier = (0, _identify.identify)({
    type: _TagTypes.TAG_TYPES.META,
    props: props
  });

  if (identifier) {
    return updateValueByIdentifier(data, identifier, props.content);
  }

  var result = (0, _clone.clone)(data);
  result.tags.push({
    type: _TagTypes.TAG_TYPES.META,
    props: props
  });
  return result;
}